import { render, staticRenderFns } from "./mark.vue?vue&type=template&id=086bc29f&scoped=true"
import script from "./mark.vue?vue&type=script&lang=js"
export * from "./mark.vue?vue&type=script&lang=js"
import style0 from "./mark.vue?vue&type=style&index=0&id=086bc29f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086bc29f",
  null
  
)

export default component.exports